import { Component, OnInit } from '@angular/core';
import { RsbLookupModel } from 'src/app/common/model/rsb-lookup.model';
import { RsbService } from 'src/app/service/rsb.service';

@Component({
  selector: 'app-sales',
  templateUrl: './sales.component.html',
  styleUrls: ['./sales.component.css']
})
export class SalesComponent implements OnInit {

  salesData: Array<any> = [];
  searchText: string = '';

  constructor(
    private rsbService: RsbService,
    private rsbLookup: RsbLookupModel
  ) { }

  ngOnInit(): void {
    this.getSalesData();
  }

  getSalesData() {
    // Replace with actual API call when available
    // this.rsbService.getSalesData().subscribe((rsp) => {
    //   if(rsp.statusCode === 0 && rsp.contents) {
    //     this.salesData = rsp.contents;
    //   } else {
    //     this.salesData = [];
    //   }
    // });
    this.salesData = [];
  }

}
